import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-6bbc8ccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-height flex-wrapper" }
const _hoisted_2 = { class: "payment-overview-block-wrapper" }
const _hoisted_3 = { class: "payment-overview-block" }
const _hoisted_4 = { class: "payment-search-wrapper" }
const _hoisted_5 = { class: "payment-search-row" }
const _hoisted_6 = { class: "search-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Entity ", -1))
const _hoisted_8 = { class: "search-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " BU ", -1))
const _hoisted_10 = { class: "search-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Submission Period ", -1))
const _hoisted_12 = { class: "search-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Priority ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item" }, null, -1))
const _hoisted_15 = { class: "search-btn" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Reset ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_18 = {
  class: "payment-overview-block-wrapper flex-height",
  style: {"padding-top":"0px"}
}
const _hoisted_19 = { class: "payment-overview-block flex-wrapper entire-height" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "To Dealer")
], -1))
const _hoisted_21 = {
  class: "payment-overview-block-wrapper flex-height",
  style: {"padding-top":"0px"}
}
const _hoisted_22 = { class: "payment-overview-block flex-wrapper entire-height" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "To MBAFC & MBLC")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_entity_selector = _resolveComponent("entity-selector")!
  const _component_bu_selector = _resolveComponent("bu-selector")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dealer_table = _resolveComponent("dealer-table")!
  const _component_fl_table = _resolveComponent("fl-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_entity_selector, {
                value: _ctx.entity,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_bu_selector, {
                value: _ctx.bu,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bu) = $event)),
                isCurrent: true
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_a_range_picker, {
                value: _ctx.period,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.period) = $event)),
                placeholder: ['Start date', 'End date'],
                format: "YYYY-MM-DD",
                allowClear: false,
                onChange: _ctx.handlePeriodChange
              }, null, 8, ["value", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_a_select, {
                value: _ctx.priority,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.priority) = $event)),
                class: "sel-inp-size",
                placeholder: "Please select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priorityList, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.value,
                      key: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_ctx.$btnPermissions('ACR-PT02', '/spotCheckingControlling'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  style: {"margin-right":"15px"},
                  onClick: _ctx.reset
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.$btnPermissions('ACR-PT01', '/spotCheckingControlling'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  type: "primary",
                  onClick: _ctx.search
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode(_component_dealer_table, {
          query: _ctx.query,
          ref: "dealerRef"
        }, null, 8, ["query"])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode(_component_fl_table, {
          query: _ctx.query,
          ref: "flRef"
        }, null, 8, ["query"])
      ])
    ])
  ]))
}